import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

// Renders schema.org JSON-LD into the document head. "<" is escaped so content can't close the script tag.
const StructuredData = ({ data }) => (
    <Helmet>
        <script type="application/ld+json">
            {JSON.stringify(data).replace(/</g, '\\u003c')}
        </script>
    </Helmet>
)

export default StructuredData

export const useSiteUrl = () => {
    const { site } = useStaticQuery(graphql`
        query SiteUrl {
            site {
                siteMetadata {
                    url
                }
            }
        }
    `)
    return site.siteMetadata.url
}

// Shared @ids so page-level schema can point at the sitewide Organization and WebSite.
export const organizationId = (siteUrl) => `${siteUrl}/#organization`
export const websiteId = (siteUrl) => `${siteUrl}/#website`

export const SiteStructuredData = () => {
    const siteUrl = useSiteUrl()

    return (
        <StructuredData data={{
            "@context": "https://schema.org",
            "@graph": [
                {
                    "@type": "Organization",
                    "@id": organizationId(siteUrl),
                    name: "54 Bit Studios",
                    legalName: "54 Bit Studios Ltd",
                    url: `${siteUrl}/`,
                    logo: {
                        "@type": "ImageObject",
                        url: `${siteUrl}/images/54-bit-studios-logo.png`,
                        width: 2082,
                        height: 990,
                    },
                    description: "A boutique web agency specialising in Shopify and Shopify Plus design, development, SEO, CRO and analytics for growing ecommerce brands.",
                    address: {
                        "@type": "PostalAddress",
                        addressLocality: "London",
                        addressCountry: "GB",
                    },
                    identifier: {
                        "@type": "PropertyValue",
                        propertyID: "Companies House company number",
                        value: "13436200",
                    },
                },
                {
                    "@type": "WebSite",
                    "@id": websiteId(siteUrl),
                    url: `${siteUrl}/`,
                    name: "54 Bit Studios",
                    inLanguage: "en-GB",
                    publisher: { "@id": organizationId(siteUrl) },
                },
            ],
        }} />
    )
}
